import React from 'react';
import { Container, Tabs, TabPanel } from '@paypalcorp/pp-react';
import { parseMessages } from '../../utilityHelper';
import { get } from 'lodash';
import ProfileTab from './ProfileTab';
import ActivityTab from './ActivityTab';
import DashboardTab from './dashboardTab';
import withTheme from '../../common/withTheme';
const propertyInfo = parseMessages("common/header-ppgf");

const GivingPanel = (props) => {
    return (
        <>
            {props.manualEnroll ?
                <ProfileTab {...props} /> :
                <Container style={{ padding: '0px', maxWidth: '74.5rem', marginBottom: '3rem' }}>
                    <Tabs name="givingTabs" selectedTabIdx={props.pageIndex} tabs={[{
                        label: get(propertyInfo, 'header.donations'),
                        id: "dashboardTabLink",
                        panelId: "dashboardTab"
                    }, {
                        label: get(propertyInfo, 'header.activity'),
                        id: "activityTabLink",
                        panelId: "activityTab"
                    }, {
                        label: get(propertyInfo, 'header.profile'),
                        id: "profileTabLink",
                        panelId: "profileTab"
                    }]} onClick={props.handleTabs}>
                        <TabPanel id="dashboardTab" style={{ margin: "0" }}>
                            <DashboardTab {...props} />
                        </TabPanel>
                        <TabPanel id="activityTab" style={{ margin: "0" }}>
                            <ActivityTab {...props} />
                        </TabPanel>
                        <TabPanel id="profileTab">
                            <ProfileTab {...props} />
                        </TabPanel>
                    </Tabs>
                </Container>}
        </>)
}

export default withTheme(GivingPanel);